import { Box, Divider, IconButton, Theme, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SText from '../../sui/stext';

export interface SHeaderProps {
  title: JSX.Element | string;
  icon?: JSX.Element;
  description?: JSX.Element | string;
  additionalContent?: JSX.Element;
  divider?: boolean;
  style?: React.CSSProperties;
  onClose?(): void;
}

const useStyles = makeStyles<
  Theme,
  { description: boolean; additionalContent: boolean }
>(({ spacing }) => ({
  container: {
    display: 'flex',
    alignItems: ({ description }) => (description ? 'start' : 'center'),
    justifyContent: ({ additionalContent }) =>
      !additionalContent ? 'space-between' : 'unset',
    padding: spacing(3, 4)
  },
  closeIcon: {
    width: 27,
    height: 27
  },
  description: {
    paddingTop: spacing(3)
  }
}));

const SHeader = ({
  title,
  icon,
  style,
  divider,
  description,
  onClose,
  additionalContent
}: SHeaderProps) => {
  const classes = useStyles({
    description: !!description,
    additionalContent: !!additionalContent
  });

  return (
    <>
      <Box className={classes.container} style={style}>
        <Box display="flex" alignItems="center" gridGap={12}>
          {icon && <Box>{icon}</Box>}
          <Box>
            {typeof title === 'string' ? (
              <SText title={title} size="xl" weight="bold" />
            ) : (
              title
            )}
            {!!description && typeof description === 'string' ? (
              <SText
                maxLines={2}
                variant="caption"
                color="textSecondary"
                title={description}
              />
            ) : (
              description
            )}
          </Box>
        </Box>
        {additionalContent && (
          <Box display="flex" alignItems="center" flex={1} mx={3}>
            {additionalContent}
          </Box>
        )}
        {onClose ? (
          <IconButton aria-label="close" size="small" onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        ) : null}
      </Box>
      {!!divider && <Divider />}
    </>
  );
};

export default SHeader;
